import React from 'react';
import { FooterButtonElement } from './FooterButton.styles';

export interface FooterButtonProps {
  buttonType: 'back' | 'next' | 'done';
  onClick: () => void;
  disabled: boolean;
}
export const FooterButton = ({ buttonType, onClick, disabled }: FooterButtonProps) => {
  const getButtonText = () => {
    switch(buttonType) {
      case 'back':
        return 'Previous Step';
      case 'next':
        return 'Proceed to Next Step';
      case 'done':
        return 'OperatorUi';
    }
  };

  return (
    <FooterButtonElement
      onClick={onClick}
      buttonType={buttonType}
      disabled={disabled}
    >
      {getButtonText()}
    </FooterButtonElement>
  );
};
